import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement, useEffect, useState } from 'react'
import { cardAddProxy } from '../CardAddSlideOver/cardAddProxy'
import { proxyGlobalAuth } from '../../proxies/proxyGlobalAuth'
import { handleBlur, handleChange } from '../CardAddSlideOver/utils'
import { CardAddFormFieldNamesEnum } from '../CardAddSlideOver/cardAddFormFieldNamesEnum'
import Spinner from '../ui/Spinner'

export function ConvergeLightboxSlideContents (): ReactElement {
  const {
    formValues,
    iframeLoading
  } = useSnapshot(cardAddProxy, { sync: true })
  const { siteTheme: { checkboxColors } } = useSnapshot(proxyGlobalAuth)

  const [showError, setShowError] = useState(false) // State to control error message display

  useEffect(() => {
    // Set a timeout for 30 seconds
    const timeout = setTimeout(() => {
      if (iframeLoading) {
        cardAddProxy.iframeLoading = false
        setShowError(true)
      }
    }, 20000)

    // Cleanup function to clear the timeout if the component unmounts
    return () => { clearTimeout(timeout) }
  }, [iframeLoading])

  return (
    <>
      <div className="text-xl mx-2 my-4">
        Step 2: Card Details
      </div>

      <div className="flex flex-row my-4">
        <input
          type="checkbox"
          className={cn(checkboxColors.classes, 'ml-2 pl-8  pr-3  h-6 w-6')}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.IsPrimary)}
          onChange={handleChange(CardAddFormFieldNamesEnum.IsPrimary)}
          checked={!!formValues.isPrimary}
        />
        <label htmlFor="checkbox" className="ml-2">Set as the primary card for this customer</label>
      </div>

      {
          iframeLoading &&
            <Spinner additionalClasses="mx-auto" color="#4878CB" size="10" />
      }

      {
            showError &&
              <div className="text-red-700 font-semibold whitespace-pre-wrap text-center text-lg">
                Error: <br />
                The operation timed out, please try again. <br />
                If the problem persists, please contact support.
              </div>
        }

      <iframe style={{ height: '400px' }} id="id_payment" className="flex w-full" />
    </>
  )
}
